import script from "./onlineRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./onlineRegistration.vue?vue&type=script&setup=true&lang=js"

import "./onlineRegistration.vue?vue&type=style&index=0&id=42930be0&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42930be0"]])

export default __exports__